import React from 'react';
import randomstring from 'uuid/v4';

import Fab from '@material-ui/core/Fab';

import ClientsDialog from './ClientsDialog';
import { AddIcon,  LinkIcon } from '../../../../images/icons/WrapSvg';

import FilterNone from '@material-ui/icons/FilterNone';

class List extends React.Component {

    state = {
        openDialog: false,
    }

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    }

    handleClick = id => (event) => {
        this.props.history.push('/manage/roles/' + id);
    }

    handleClone = id => (event) => {
        this.props.history.push('/manage/roles/clone/' + id);
    }

    handleClickDialog = (event) => {
        this.setState({ openDialog: true });
    }

    handleCloseDialog = (client) => {
        console.log(client);
        if (client) {
            this.props
                .cloneRoles(client)
                .catch((error) => this.props.onError( error.message, error.type ));
        }
        this.setState({ openDialog: false });
    }

    render() {
        const { openDialog } = this.state;
        const { roles, info, levels } = this.props;

        return (
            <div className={'flex_full_column height100'}>
                <div className="flex_full overflow_y_scroll showbar padding_top_12 " onScroll={this.handleScroll}>
                    {
                        levels.map((l) =>
                            <div
                                key={randomstring()}
                                className={"flex_full_row padding_borders " + (l ? "border_bottom_gray" : "")}>
                                <span className="barlowsemicondensed_semibold_link c_disabled padding_bottom_24 margin_right_12 ">{l}</span>
                                <div className="flex_full_row wrap">
                                    {roles
                                        .filter((f) => f.nivel === l)
                                        .map((r) =>
                                            <div
                                                key={randomstring()}
                                                className="flex_auto_row boxBorder padding_top_6 padding_bottom_6  padding_left_6 padding_right_6 margin_left_6 margin_right_6 margin_bottom_12 bg_bluish c_white hand align_center">
                                                <span 
                                                    onClick={this.handleClick(r.id)}
                                                    className="margin_right_6">
                                                    {r.nombre}
                                                </span>
                                                <FilterNone 
                                                    className="c_white" 
                                                    onClick={this.handleClone(r.id)} />
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        )
                    }
                    {info &&
                        info.security &&
                        info.security.totalPermits &&
                        info.security.totalPermits.some(
                            (f) => f === '20',
                        ) &&
                            <Fab
                                color="secondary"
                                aria-label="link"
                                className="button_float_50_over button_suppervisor"
                                onClick={this.handleClickDialog}
                            >
                                <LinkIcon />
                            </Fab>
                    }
                    <Fab
                        color="primary"
                        aria-label="add"
                        className={'button_float_50'}
                        onClick={this.handleClick('new')}
                    >
                        <AddIcon />
                    </Fab>
                    {openDialog && <ClientsDialog {...this.props} onClose={this.handleCloseDialog} />}
                </div>

            </div>
        )
    }
}

export default List;



// WEBPACK FOOTER //
// ./src/components/complex/manage/roles/profesional.js